import React from 'react';

function TradeRow({ ts, event, payload }) {
  if (!payload) return null;
  const p = typeof payload === 'string' ? JSON.parse(payload) : payload;
  return (
    <tr>
      <td>{ts}</td>
      <td>{event}</td>
      <td>{p.price ? `$${p.price}` : '—'}</td>
      <td>{p.qty || '—'}</td>
      <td className={p.pnl_usd > 0 ? 'green' : p.pnl_usd < 0 ? 'red' : ''}>
        {p.pnl_usd ? `$${Number(p.pnl_usd).toFixed(2)}` : '—'}
      </td>
    </tr>
  );
}

function Trades({ openTrades, closedTrades }) {
  const open = openTrades || [];
  const closed = closedTrades || [];
  return (
    <section className="trades">
      <h2>Trades</h2>

      <h3>Open entries</h3>
      <table>
        <thead>
          <tr><th>Time</th><th>Event</th><th>Price</th><th>Qty</th><th>PnL</th></tr>
        </thead>
        <tbody>
          {open.length ? open.map(t => <TradeRow key={t.id} {...t} />) : <tr><td colSpan="5">No entries yet.</td></tr>}
        </tbody>
      </table>

      <h3>Closed trades</h3>
      <table>
        <thead>
          <tr><th>Time</th><th>Event</th><th>Price</th><th>Qty</th><th>PnL</th></tr>
        </thead>
        <tbody>
          {closed.length ? closed.map(t => <TradeRow key={t.id} {...t} />) : <tr><td colSpan="5">No closed trades yet.</td></tr>}
        </tbody>
      </table>
    </section>
  );
}

export default Trades;
